/* eslint-disable array-callback-return */
import React, { memo, useEffect, useState } from 'react'
import { Handle, Position } from 'reactflow'
import '../../Styles/CustomNode.css'
import PropTypes from 'prop-types'
import { Avatar, Box, Chip, Dialog, IconButton, Tooltip } from '@mui/material'
import MinusRoundedRectangleIcon from '../../Common/Icon/MinusRoundedRectangleIcon'
import PlusRoundedRectangleIcon from '../../Common/Icon/PlusRoundedRectangleIcon'
import NodeDetailsPopper from './NodeDetailsPopper'
import { IoCloseCircleOutline, IoWarning } from 'react-icons/io5'
import { MdOutlineModeEdit } from 'react-icons/md'
import dayjs from 'dayjs'
import MoardMemberDetailsPopper from './MoardMemberDetailsPopper'
import { useCommonStore } from '../../Common/store/CommonStore'
import { toast } from 'react-toastify'
import { useBoardMemberStore } from 'src/Containers/Governance/store/BoardMemberStore'
import { BiCopy, BiSolidCopy } from 'react-icons/bi'
import { cn, featValid } from 'src/lib/utils'
import * as XLSX from 'xlsx'
import { CREATE_ORGCHART, UPDATE_ORGCHART } from 'src/Entities/Features'
import { BsThreeDotsVertical } from 'react-icons/bs'
import NodeMenu from './NodeMenu'

function CustomNode ({ data }) {
    const { userProfileModalHide, nodeModalData, setNodeModalData } = useBoardMemberStore()

    const { rollData } = useCommonStore()
    const [ anchorEl, setAnchorEl ] = useState(null)
    const meetingTypes = data?.meetingType?.filter((filterDt) => filterDt?.isSelected === true)?.map((mapDt) => mapDt?.title?.replace(' Team', ''))
    // const [ nodeModalData, setNodeModalData ] = useState({})
    const [ modalOpen, setModalOpen ] = useState(false)
    const [ isCopy, setIsCopy ] = useState({ phNumber: false, emailId: false })
    const [ isHovered, setIsHovered ] = useState(false)
    const handleMouseEnter = (event) => {
        setAnchorEl(event.currentTarget)
        setIsHovered(true)
    }

    // NodeMenuModel - Start
    const [ anchorElMenu, setAnchorElMenu ] = useState(null)
    const openMenu = Boolean(anchorElMenu)
    const handleClickMenu = (event) => {
        setAnchorElMenu(event.currentTarget)
    }
    const handleCloseMenu = () => {
        setAnchorElMenu(null)
    }
    // NodeMenuModel - End

    const [ roleData, setRoleData ] = useState([])

    const handleCloseNodeModal = () => {
        setNodeModalData({})
        setModalOpen(!modalOpen)
        userProfileModalHide()
        setIsCopy({ ...isCopy, phNumber: false, emailId: false })
    }

    useEffect(() => {
        if (rollData?.length > 0) {
            setRoleData(rollData)
        }
    }, [rollData])
    const features = JSON.parse(localStorage.getItem('features'))

    const Governance = roleData?.filter((filterDt) => filterDt?.roleGroups === 1)?.map((mapDt) => mapDt?.name)
    const Risk = roleData?.filter((filterDt) => filterDt?.roleGroups === 3)?.map((mapDt) => mapDt?.name)
    const Compliance = roleData?.filter((filterDt) => filterDt?.roleGroups === 2)?.map((mapDt) => mapDt?.name)

    const handleMouseLeave = () => {
        setAnchorEl(null)
        setIsCopy({ ...isCopy, phNumber: false, emailId: false })
        setIsHovered(false)
    }
    const mapGrcData = data?.role?.map((mapDt) => {
        if (Governance?.includes(mapDt)) {
            return 'Executives'
        }
        if (Risk?.includes(mapDt)) {
            return 'Risk'
        }
        if (Compliance?.includes(mapDt)) {
            return 'Compliance'
        }
    })
    const handleCompliancePreview = () => {
        // navigate('/GRC/compliance-preview') // Pass data via state
        return data
    }
    const handleDownloadUserDetails = () => {
        const downData = [
            {
                S_No: 1,
                Name: nodeModalData?.firstName + ' ' + nodeModalData?.lastName,
                Designation: nodeModalData?.designation || '',
                Department: nodeModalData?.department,
                Role: nodeModalData?.role?.join(','),
                Level: nodeModalData?.level?.toString().padStart(2, '0'),
                Email_ID: nodeModalData?.emailId,
                PhoneNumber: nodeModalData?.phoneNumber,
                // commented because of at present removed
                // - ${nodeModalData?.atPresent === true ? 'Present' : dayjs(nodeModalData?.to).format('DD/MMM/YYYY')}
                Duration: `${dayjs(nodeModalData?.fromDate).format('DD/MMM/YYYY')} `,
                Reports_To_Name: nodeModalData?.parentName || '',
                Reports_To_Designation: nodeModalData?.parentDesignation || '',
                Reports_To_Role: nodeModalData?.parentRole?.join(',') || ''
            }
        ]
        const ws = XLSX.utils.json_to_sheet(downData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

        XLSX.writeFile(wb, `${nodeModalData?.firstName + ' ' + nodeModalData?.lastName} UserDetails.csv`)
    }

    return (
        !data?.isBoardMember
            ? <div style={{
                fontFamily: 'SF Pro',
                fontWeight: 'bold',
                pointerEvents: data?.meetingType?.some((mapDt) => mapDt?.isSelected) && ![...new Set(mapGrcData)]?.filter((filData) => meetingTypes?.includes(filData))?.length > 0 && 'none',
                backgroundColor: 'hsl(var(--foreground))',
                borderRadius: '10px',
                // boxShadow: '0px 1px 9px 0px hsl(var(--shadow))',
                width: 300,
                height: 128,
                filter: data?.meetingType?.some((mapDt) => mapDt?.isSelected) && ![...new Set(mapGrcData)]?.filter((filData) => meetingTypes?.includes(filData))?.length > 0 && 'grayscale(100%)',
                opacity: data?.meetingType?.some((mapDt) => mapDt?.isSelected) && ![...new Set(mapGrcData)]?.filter((filData) => meetingTypes?.includes(filData))?.length > 0 && '0.4',
                boxShadow: isHovered ? 'inset 0px 0px 0px 3px hsl(var(--primary))' : '0px 1px 9px 0px hsl(var(--shadow))',
                transform: isHovered ? 'scale(1.05)' : 'scale(1)'
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            >
                <Handle type="target" position={Position.Top} className="w-16" />
                <div style={{
                    height: '10px',
                    width: '100%',
                    borderRadius: '20px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly'
                }}>
                    {
                        [...new Set(mapGrcData)]?.filter((filData) => meetingTypes?.includes(filData))?.map((mapDt, ind) => {
                            return <div
                                key={ind}
                                style={{
                                    height: '100%',
                                    width: '100%',
                                    borderRadius: '10px 10px 0px 0px',
                                    borderTopLeftRadius: ind === 0 ? '10px' : '0',
                                    borderTopRightRadius: ind === [...new Set(mapGrcData)]?.filter((filData) => meetingTypes?.includes(filData)).length - 1
                                        ? '13px'
                                        : '0',
                                    backgroundColor: isHovered ? `hsl(var(--${mapDt}))` : `hsl(var(--${mapDt}-hover))`
                                }}
                            />
                        })
                    }
                </div>
                <div style={{ display: 'flex', padding: '10px', height: '82px', flexDirection: 'row', alignItems: 'center' }}>
                    <div onClick={() => {
                        setNodeModalData(data)
                        setModalOpen(!modalOpen)
                    }} style={{ width: '60px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60px', borderRadius: '50%', border: '1px solid #0657ae', marginRight: '10px' }}>
                        {/* <img style={{ width: '30px', height: '30px' }} src={data?.profilePic || '/Assets/ProfileIconSvg.svg'} alt="Profile Icon" /> */}
                        <Avatar sx={{ width: 60, height: 60 }} src={data?.profilePic ? `data:${data?.profilePic?.contentType};base64,${data?.profilePic?.file}` : data?.name} alt={data?.name} />
                    </div>
                    <div className='w-[65%]'>
                        <div className='whitespace-nowrap overflow-hidden overflow-ellipsi' style={{ fontSize: '18px', width: '100%', color: 'hsl(var(--primary))' }}>{data?.department}</div>
                        {/* <div className='flex flex-row items-center w-[100%]'><p className={`w-[${data?.role?.length > 1 ? '80%' : '100%'}] whitespace-nowrap text-ellipsis overflow-hidden ...`} style={{ fontSize: '15px', color: 'hsl(var(--shadow))' }}>{data?.role && data?.role[0]}</p>{data?.role?.length > 1 && <span className='w-[20%] text-[14px] text-center rounded-[50px] bg-primary-foreground text-primary'>+{data?.role?.length - 1}</span>}</div> */}
                        <div className='flex flex-row items-center w-[100%]'><p className={`w-[${data?.role?.length > 1 ? '80%' : '100%'}] whitespace-nowrap text-ellipsis overflow-hidden ...`} style={{ fontSize: '15px', color: 'hsl(var(--shadow))' }}>{data?.designation}</p></div>
                    </div>
                    {/*  */}
                    {featValid(features, UPDATE_ORGCHART) && <div style={{ height: '100%' }}>
                        <Tooltip title="More" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginLeft: 'auto', cursor: 'pointer', padding: '1px' }} onClick={handleClickMenu} >
                                <BsThreeDotsVertical color='#007876'/>
                            </IconButton>
                        </Tooltip>

                        {/* Render the NodeMenu Component */}
                        <NodeMenu
                            anchorElMenu={anchorElMenu}
                            openMenu={openMenu}
                            handleCloseMenu={handleCloseMenu}
                            handleCompliancePreview={handleCompliancePreview}
                            data={data}
                        />
                    </div>}

                </div>
                <div style={{ left: '10px', right: '10px', borderRadius: '5px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <div className='whitespace-nowrap h-[36px] overflow-hidden overflow-ellipsi' style={{ fontSize: '15px', color: 'hsl(var(--primary))', width: '100%', textAlign: 'center', backgroundColor: 'hsl(var(--primary-foreground))', padding: '5px 0px 5px 0px', borderRadius: '0px 0px 9px 9px' }}>{data?.displayName ? data?.displayName : <div className='flex flex-row justify-center items-center'><IoWarning className='mr-[5px] h-[20px] w-[20px]' color='hsl(var(--danger))' /><p className='text-danger'>Vacant</p></div>}</div>
                    {featValid(features, CREATE_ORGCHART) && <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', marginTop: '-16px' }}>
                        <Tooltip title="Delete User" placement="left" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton sx={{ padding: '0px' }} onClick={() => data?.handleOpenNodeDeleteModal(data)} ><MinusRoundedRectangleIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Add User" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton sx={{ padding: '0px' }} onClick={() => data?.handleDrawerOpen(data)}><PlusRoundedRectangleIcon /></IconButton>
                        </Tooltip>
                    </div>}
                    <NodeDetailsPopper Compliance={Compliance} Risk={Risk} Governance={Governance} isCopy={isCopy} setIsCopy={setIsCopy} anchorEl={anchorEl} handleClose={handleMouseLeave} nodeData={data} />
                </div>
                <Handle type="source" style={{ top: 'auto' }} position={Position.Bottom} className="w-16" />
                <Dialog
                    open={Object.keys(nodeModalData).length > 0 && modalOpen}
                    onClose={handleCloseNodeModal}
                    PaperProps={{
                        style: {
                            minWidth: '850px'
                        }
                    }}
                    aria-describedby="alert-dialog-description"
                >
                    <div className='w-full p-[8px] bg-primary flex flex-row'>
                        <div className='w-[90%] flex flex-row justify-center items-center'>
                            <p className='text-[22px] font-medium text-card mr-[-10%]'>User Profile</p>
                        </div>
                        <div className='w-[10%] flex flex-row justify-end'>
                            <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <IconButton onClick={handleCloseNodeModal}>
                                    <IoCloseCircleOutline className='text-card' fontSize={30} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                    <div className='p-[32px]'>
                        <div className='flex flex-row justify-between pb-4'>
                            <div className='flex flex-row items-center'>
                                <Avatar sx={{ width: 60, height: 60 }} src={nodeModalData?.profilePic ? `data:${nodeModalData?.profilePic?.contentType};base64, ${nodeModalData?.profilePic?.file}` : nodeModalData?.name} alt={nodeModalData?.name} />
                                <div className='flex min-h-[60px] max-h-[120px] flex-col justify-between ml-4' >
                                    <div className="flex flex-row">
                                        <p className='text-[20px] text-primary font-semibold'>{nodeModalData?.displayName}</p>
                                        <div className="ml-3">
                                            <Chip label={nodeModalData.isActive ? 'Active' : 'In Active'} style={{ backgroundColor: nodeModalData.isActive ? 'hsl(var(--primary))' : 'hsl(var(--Risk))', color: 'white', height: '20px' }}/>
                                        </div>
                                    </div>
                                    <p className='flex flex-row items-center text-primary font-medium flex-wrap mb-1 gap-2' ><span className='mr-[10px] text-[16px] text-primary font-semibold'>Role </span>{nodeModalData?.role?.map((mapDt, ind) => {
                                        const checkRoleCategory = (roleDt) => {
                                            if (Governance?.includes(roleDt)) {
                                                return 'Governance'
                                            }
                                            if (Risk?.includes(roleDt)) {
                                                return 'Risk'
                                            }
                                            if (Compliance?.includes(roleDt)) {
                                                return 'Compliance'
                                            }
                                        }
                                        return <Chip style={{ height: '25px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${checkRoleCategory(mapDt)}))`, marginRight: '5px' }} key={ind} label={mapDt} />
                                    })}</p>
                                </div>
                            </div>
                            <div className='flex flex-row items-center' >
                                <Tooltip title="Download User Details" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <IconButton style={{ height: '45px', width: '45px', border: 'none' }} onClick={handleDownloadUserDetails}>
                                        <img src={'/Common/Icon/Download.svg'} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit User" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <IconButton style={{ height: '50px', width: '50px', border: 'none', marginLeft: '5px' }} onClick={() => data?.handleEditDrawerOpen(data)}>
                                        <MdOutlineModeEdit color='hsl(var(--primary))' size={30} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            <Box gridColumn="span 12" >
                                <p className='text-[18px] text-primary font-bold pt-4'>More Info </p>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Full Name </p>
                                    <p className='ml-[5px] text-[16px]'>{nodeModalData?.firstName + ' ' + nodeModalData?.lastName }</p>
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Designation  </p>
                                    <p className='ml-[5px] text-[16px]'>{nodeModalData?.designation}</p>
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Department  </p>
                                    <p className='ml-[5px] text-[16px]'>{nodeModalData?.department}</p>
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Level </p>
                                    <p className='ml-[5px] text-[16px]'>{nodeModalData?.level?.toString().padStart(2, '0')}</p>
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2 items-center'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Email ID  </p>
                                    <p className={cn(nodeModalData?.emailId?.length >= 25 && 'w-[60%] break-words text-wrap', 'ml-[5px] text-[16px]')}>{nodeModalData?.emailId}</p>
                                    {!isCopy?.emailId
                                        ? <Tooltip title="Copy EmailID" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <div><BiCopy color='hsl(var(--primary))' onClick={() =>
                                                navigator.clipboard.writeText(nodeModalData?.emailId)
                                                    .then((data) => {
                                                        setIsCopy({ ...isCopy, emailId: true })
                                                        toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Email id is Copied to clipboard</p></p>, {
                                                            position: 'top-right',
                                                            autoClose: 5000,
                                                            hideProgressBar: true,
                                                            closeButton: false,
                                                            theme: 'light'
                                                        })
                                                    })
                                            } className='ml-[10px] cursor-pointer' />
                                            </div></Tooltip>
                                        : <BiSolidCopy color='hsl(var(--primary))' onClick={() =>
                                            navigator.clipboard.writeText(nodeModalData?.emailId)
                                                .then((data) => {
                                                    setIsCopy({ ...isCopy, emailId: true })
                                                    toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Email id is Copied to clipboard</p></p>, {
                                                        position: 'top-right',
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeButton: false,
                                                        theme: 'light'
                                                    })
                                                })
                                        } className='ml-[10px] cursor-pointer' />}
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2 items-center'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Phone Number </p>
                                    <p className='ml-[5px] text-[16px]'>{nodeModalData?.phoneCode + ' ' + nodeModalData?.phoneNumber}</p>
                                    {
                                        !isCopy?.phNumber
                                            ? <Tooltip title="Copy Phone Number" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <div><BiCopy color='hsl(var(--primary))' onClick={() =>
                                                    navigator.clipboard.writeText(nodeModalData?.phoneNumber)
                                                        .then((data) => {
                                                            setIsCopy({ ...isCopy, phNumber: true })
                                                            toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Phone Number is Copied to clipboard</p></p>, {
                                                                position: 'top-right',
                                                                autoClose: 5000,
                                                                hideProgressBar: true,
                                                                closeButton: false,
                                                                theme: 'light'
                                                            })
                                                        })
                                                } className='ml-[10px] cursor-pointer' />
                                                </div></Tooltip>
                                            : <BiSolidCopy color='hsl(var(--primary))' onClick={() =>
                                                navigator.clipboard.writeText(nodeModalData?.phoneNumber)
                                                    .then((data) => {
                                                        setIsCopy({ ...isCopy, phNumber: true })
                                                        toast(<p className='w-[100%] flex flex-row justify-evenly items-center' ><BiSolidCopy color='hsl(var(--primary))'/><p>Phone Number is Copied to clipboard</p></p>, {
                                                            position: 'top-right',
                                                            autoClose: 5000,
                                                            hideProgressBar: true,
                                                            closeButton: false,
                                                            theme: 'light'
                                                        })
                                                    })
                                            }
                                            className='ml-[10px] cursor-pointer' />}
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div className='flex flex-row py-2'>
                                    <p className='text-[16px] w-[130px] text-primary font-semibold'>Effective From </p>
                                    <p className='ml-[5px] text-[16px]'>{`${dayjs(nodeModalData?.fromDate).format('MMM DD, YYYY')} - ${nodeModalData?.atPresent === true ? 'Till Date' : dayjs(nodeModalData?.to).format('MMM DD, YYYY')}`}</p>
                                </div>
                            </Box>
                        </Box>
                        {nodeModalData?.parentRole?.length > 0 && <Box >
                            <p className='text-[18px] text-primary font-bold pt-[24px] pb-[16px]'>Reports to</p>
                        </Box>}
                        {nodeModalData?.parentRole?.length > 0 && <div className='flex flex-row items-center py-2'>
                            {/* <Avatar style={{ width: '40px', height: '40px' }} /> */}
                            {nodeModalData?.parentProfilePic
                                ? <div className='h-[40px] w-[40px]'><img style={{ width: '100%', height: '100%', borderRadius: '50%' }} src={`data:${nodeModalData?.parentProfilePic?.contentType};base64, ${nodeModalData?.parentProfilePic?.file}`} alt="Profile Icon" /></div>
                                : <Avatar sx={{ width: 60, height: 60 }} alt={nodeModalData?.parentName} />
                            }
                            <div className='flex h-[60px] flex-col pt-2 ml-4' >
                                <p className='text-[18px] text-primary font-semibold'>{nodeModalData?.parentName || <div className='flex flex-row justify-center items-center'><IoWarning className='mr-[5px] h-[20px] w-[20px]' color='hsl(var(--danger))' /><p className='text-danger'>Vacant</p></div>}</p>
                                <p className='text-[16px]'>{nodeModalData?.parentDesignation}</p>
                            </div>
                            <div className='flex h-[60px] flex-col justify-center ml-6' >
                                <p className='flex flex-row items-center text-primary font-semibold' ><span className='mr-[10px]'>Role </span>{nodeModalData?.parentRole?.map((mapDt, ind) => {
                                    const checkRoleCategory = (roleDt) => {
                                        if (Governance?.includes(roleDt)) {
                                            return 'Governance'
                                        }
                                        if (Risk?.includes(roleDt)) {
                                            return 'Risk'
                                        }
                                        if (Compliance?.includes(roleDt)) {
                                            return 'Compliance'
                                        }
                                    }
                                    return <Chip style={{ height: '25px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${checkRoleCategory(mapDt)}))`, marginRight: '5px' }} key={ind} label={mapDt} />
                                })}</p>
                            </div>
                        </div>}
                    </div>
                </Dialog>
            </div>
            : <div style={{
                fontFamily: 'SF Pro',
                fontWeight: 'bold',
                backgroundColor: 'hsl(var(--primary-thick-foreground))',
                borderRadius: '10px',
                width: 300,
                height: 128
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            >
                <Handle type="target" position={Position.Top} className="w-16" />
                <div style={{ left: '10px', right: '10px', borderRadius: '5px', height: '90%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <p className='text-primary text-[18px]'>
                        {'Board Member'}
                    </p>
                </div>
                <div style={{ left: '10px', right: '10px', borderRadius: '5px', height: '10%', marginTop: '14px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'end' }}>
                    <Tooltip title="Add User" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton sx={{ padding: '0px' }} onClick={() => data?.handleDrawerOpen(data)}><PlusRoundedRectangleIcon /></IconButton>
                    </Tooltip>
                </div>
                <MoardMemberDetailsPopper anchorEl={anchorEl} handleClose={handleMouseLeave} nodeData={data} />
                <Handle type="source" style={{ top: 'auto' }} position={Position.Bottom} className="w-16" />
            </div>
    )
}

CustomNode.propTypes = {
    data: PropTypes.object
}

export default memo(CustomNode)
